export default __webpack_public_path__ + "static/media/bestof_3.5c99dddf.jpg";